import React from "react";
import { seriesContacts, categories } from "./data";
import { ChartsSetWrapper } from "../../../../../components";

const LineList = () => {
  return (
    <div className="flex-1 flex overflow-auto">
      <div className="flex-1  grid grid-cols-2 auto-rows-[400px] gap-4">
        <ChartsSetWrapper
          title="Line Chart Simple"
          type="line"
          series={seriesContacts}
          categories={categories}
          loading={false}
        />
        <ChartsSetWrapper
          title="Line Chart with Scrolling"
          type="line"
          series={seriesContacts}
          categories={categories}
          options={{
            axis: {
              x: {
                scroll: { enabled: true, bandWidth: 120 },
              },
            },
          }}
          loading={false}
        />
        <ChartsSetWrapper
          title="Line Chart with Options"
          type="line"
          series={seriesContacts}
          categories={categories}
          options={{
            colors: ["primary-800", "info-500", "danger-500"],
            padding: { top: 40, right: 30, bottom: 40, left: 40 },
            axis: {
              color: "gray-200",
              labelColor: "gray-400",
              edgePadding: 50,
              y: {
                gridLines: 6,
                //clampMinZero: true,
              },
            },
            grid: {
              color: "info-100",
              dasharray: "1 1",
              strokeWidth: 2,
              horizontal: true,
              vertical: true,
              background: "primary-50",
            },
            showLabels: {
              show: true,
              valueDisplay: "value",
              color: "gray-400",
              fontSize: 8,
              strategy: "hide",
            },
            background: "gray-100",
            line: {
              stroke: { width: 0.3, curve: "straight" },
              markers: { size: 5 },
            },
            legend: {
              mode: "select",
            },
          }}
        />
      </div>
    </div>
  );
};

export default LineList;
